<template>
	<form @submit.prevent="onSubmit">
		<message-box v-if="errors && errors.email" type="error" :message="errors.email" ></message-box>
		<smart-input required type="email" v-model="form.email" label="אימייל"/>
		<smart-input type="password" v-model="form.password" label="סיסמה"/>
		<v-btn type="submit" color="primary">התחברות</v-btn>
	</form>
</template>

<script>
	import {types} from "../../store/modules/Auth.module";
	import LaravelErrors from "../../helpers/LaravelErrors";

	export default {
		name: "login-form",
		props:{redirect:Object},
		data() {
			return {

				form: {
					email: null,
					password: null
				},
				errors: {}
			};
		},
		methods: {
			async onSubmit() {
				try {
					this.errors = null;
					await this.$store.dispatch(types.LOGIN, this.form);
					await this.$router.replace(this.redirect);
				} catch (e) {
					this.errors = LaravelErrors.fromErrorObject(e) || {};
				}
			}
		}
	};
</script>

<style scoped>

</style>
